import { FingerprintJSProvider, splitSDKConfig } from "@brandclub/common-ui";
import { SplitFactoryProvider } from "@splitsoftware/splitio-react";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import CheckoutShopApp from "./CheckoutShopApp";
import "./main.css";
import "./main.generated.css";
import { BCRoutingContextProvider } from "./providers/BCRoutingContextProvider";
import getStore from "./redux/store";
import { AppInitializer } from "./AppInitializer";
import { QueryClientProvider } from "@tanstack/react-query";
import { HOST_DOMAIN } from "./utils/domain";
import { queryClient } from "./api/cache/queryClient";
import { LocationTrackingContextProvider } from "./providers/LocationTrackingContextProvider";

export default function render() {
  const root = ReactDOM.createRoot(document.body);
  root.render(
    <React.StrictMode>
      <BCRoutingContextProvider>
        <QueryClientProvider client={queryClient}>
          <Provider store={getStore()}>
            <LocationTrackingContextProvider>
              <AppInitializer>
                <CheckoutShopApp />
              </AppInitializer>
            </LocationTrackingContextProvider>
          </Provider>
        </QueryClientProvider>
      </BCRoutingContextProvider>
    </React.StrictMode>
  );
}
export function renderBarScript() {
  document.body
    .appendChild(document.createElement("div"))
    .classList.add("BCCheckoutBar");
  const appElement = document.querySelector(".BCCheckoutBar");
  const body = document.querySelector("body");

  if (!body) return;

  if (appElement) {
    appElement.id = "BCCheckoutBar";
    const root = ReactDOM.createRoot(appElement);
    root.render(
      <React.StrictMode>
        <BCRoutingContextProvider>
          <QueryClientProvider client={queryClient}>
            <Provider store={getStore()}>
              <SplitFactoryProvider config={splitSDKConfig}>
                <FingerprintJSProvider hostDomainName={HOST_DOMAIN}>
                  <LocationTrackingContextProvider>
                    <AppInitializer>
                      <CheckoutShopApp />
                    </AppInitializer>
                  </LocationTrackingContextProvider>
                </FingerprintJSProvider>
              </SplitFactoryProvider>
            </Provider>
          </QueryClientProvider>
        </BCRoutingContextProvider>
      </React.StrictMode>
    );
  }
}
